import state from './listingState';
import ApiListing from './apiListing';

export default {
    namespaced: true,
    state() {
        return {
            metaUrl: 'ocr/pur-invoice/metas',
            permissions: {
                create_payment: false,
            },
            metadatas: {},
        };
    },
    mutations: {
        setAjax(state, xhttpRequest) {
            state.ajax = xhttpRequest;
        },
        updatePermissions(state, permissions) {
            state.permissions = permissions;
        },
    },
    getters: {
        permissions(state) {
            return state.permissions || {};
        },
    },
    actions: {
        async init({ dispatch }) {
            await dispatch('loadMeta');
        },
        loadMeta({ state, commit }) {
            if (state.metaUrl === null) {
                return Promise.resolve();
            }
            return new Promise((resolve, reject) => {
                commit(
                    'setAjax',
                    ApiClient.get(state.metaUrl)
                        .then(function (response) {
                            try {
                                const permissions = response.data;

                                if (typeof permissions === 'object') {
                                    commit(
                                        'updatePermissions',
                                        Object.assign(state.permissions, permissions),
                                    );
                                }
                                resolve(permissions);
                            } catch (e) {
                                reject(e);
                            }
                        })
                        .catch(function () {
                            reject();
                            commit('setAjax', false);
                        }),
                );
            });
        },
    },
};
